export default __webpack_public_path__ + "static/media/art-4-beetroot-sm.1b1d70ab.jpg";